var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Foot"}},[_c('div',{attrs:{"id":"footer"}},[_vm._v("\n    Copyright © 2019 西窗烛 |\n    "),_c('a',{attrs:{"href":"http://www.miibeian.gov.cn","target":"_blank"}},[_vm._v("京ICP备16067195号")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bed3856","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 1552
// module chunks = 0